import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const RewardsEmptyWhite: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--rewards-empty-white')}
    viewBox="0 0 20 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      d="M14.486 11.296l5.26-4.474-6.928-.578L10.123 0 7.428 6.244.5 6.822l5.26 4.474-1.577 6.637 5.94-3.52 5.94 3.52-1.577-6.637zm-4.363 1.954L5.7 15.87l1.173-4.938L2.98 7.618l5.129-.427 2.014-4.667 2.014 4.667 5.129.427-3.894 3.314 1.173 4.939-4.422-2.621z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default RewardsEmptyWhite;
